const WHATSAPP_NUMBER = '255711416873';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export default function FloatingWhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      title="Chat on WhatsApp"
      style={{
        position: 'fixed',
        right: '18px',
        bottom: '18px',
        zIndex: 60,
        width: '58px',
        height: '58px',
        borderRadius: '9999px',
        background: '#25D366',
        boxShadow: '0 12px 30px rgba(37, 211, 102, 0.45)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 180ms ease, box-shadow 180ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px) scale(1.03)';
        e.currentTarget.style.boxShadow = '0 16px 34px rgba(37, 211, 102, 0.55)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow = '0 12px 30px rgba(37, 211, 102, 0.45)';
      }}
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          fill="#fff"
          d="M20.52 3.48A11.87 11.87 0 0 0 12.05 0C5.48 0 .14 5.34.14 11.91c0 2.1.55 4.15 1.59 5.95L0 24l6.31-1.65a11.9 11.9 0 0 0 5.74 1.47h.01c6.57 0 11.91-5.34 11.91-11.91 0-3.18-1.24-6.17-3.45-8.43Zm-8.46 18.3h-.01a9.96 9.96 0 0 1-5.07-1.39l-.36-.21-3.74.98 1-3.65-.23-.37a9.95 9.95 0 0 1-1.53-5.25c0-5.49 4.47-9.95 9.96-9.95a9.9 9.9 0 0 1 7.04 2.92 9.89 9.89 0 0 1 2.91 7.03c0 5.49-4.47 9.95-9.97 9.95Zm5.46-7.47c-.3-.15-1.77-.88-2.04-.98-.27-.1-.47-.15-.66.15-.2.3-.76.98-.94 1.18-.17.2-.35.22-.64.07-.3-.15-1.24-.46-2.36-1.46a8.8 8.8 0 0 1-1.64-2.03c-.17-.3-.02-.45.13-.59.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.66-1.6-.91-2.2-.24-.58-.49-.5-.66-.5h-.57c-.2 0-.52.08-.8.37s-1.05 1.02-1.05 2.49 1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.08 4.48.71.31 1.27.5 1.7.64.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.03-1.41.25-.69.25-1.28.17-1.4-.08-.12-.28-.2-.58-.35Z"
        />
      </svg>
    </a>
  );
}
